export const ThousandsSeparators = (amount: number | undefined) => {
  if (amount === undefined) return "";
  return amount.toLocaleString("en-SA", { maximumFractionDigits: 2 });
};

export const CapitalizeFirstLetterOfEachWord = (str: string) => {
  const splitStr = str.toLowerCase().split(" ");

  splitStr.map((item, index) => {
    return (splitStr[index] = item.charAt(0).toUpperCase() + item.substring(1));
  });

  return splitStr.join(" ");
};

export const maskText = (text: string, start: number, end = 5) => {
  if (!text || typeof text !== "string") return "";

  return (
    text.substring(0, start) +
    text.substring(start, end).replace(/[a-zA-Z\u0621-\u064A\d]/g, "*") +
    text.substring(end)
  );
};

function utf8ToBase64(str: string) {
  return btoa(encodeURIComponent(str));
}

export const hashObject = (obj: Record<string, unknown>) => {
  try {
    const stringified = JSON.stringify(obj);
    const hashed = utf8ToBase64(stringified);
    return hashed;
  } catch (error) {
    console.error((error as Error).message);
  }
};

function base64ToUtf8(base64String: string) {
  const binaryString = atob(base64String);
  const decodedString = decodeURIComponent(binaryString);
  return decodedString;
}

export const decodeHashedObject = <T = Record<string, unknown>>(
  hash: string,
) => {
  try {
    const decoded = base64ToUtf8(hash);
    const obj = JSON.parse(decoded);
    return obj as T;
  } catch (error) {
    console.error((error as Error).message);
  }
};

export function formatDate(
  dateInput: Date | string | undefined,
  locale = "en",
) {
  if (!dateInput) return "";

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date input");
  }

  return date.toLocaleDateString(locale, {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}
